import UserInfo from '../../../models/UserInfo';
import Application from '../../../models/Application';
import ApplicationsActions from '../../../models/ApplicationsActions';

export class UserState {
  public info?: UserInfo = undefined;
  public allowedApps?: Application[];
  public profileUrl?: string;
  public logoutUrl = '/logout';
  public applicationsActions: ApplicationsActions = {};
  public loaded = false;
}

export const state: UserState = new UserState();
